import {
    createMountsGlazingGasketConfig,
    createMountsToptrackSlidingDoorConfig,
    createMountsCGFChannelHorizontalConfig,
    createMountsCGFChannelVerticalConfig,
    createMountsCGFFrameVerticalConfig,
    createMountsFunctionalMullionsConfig,
} from "../../base";
import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createSlidingDoorMountsToptrackSlidingDoorConfig = (
    partition: Partition,
): IComponentConfig => {
    const toptrackStuctureCode = MountsService.getTopTrack(partition);

    return createMountsToptrackSlidingDoorConfig()
        .structureType(toptrackStuctureCode)
        .qty(0)
        .area(1)
        .build();
};

const createSlidingDoorMountsCGFFrameVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameVertical(partition);

    return createMountsCGFFrameVerticalConfig().qty(0).area(length).build();
};

const createSlidingDoorMountsCGFChannelVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelVertical(partition);

    return createMountsCGFChannelVerticalConfig().qty(0).area(length).build();
};

const createSlidingDoorMountsCGFChannelHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelHorizontal(partition);

    return createMountsCGFChannelHorizontalConfig().qty(0).area(length).build();
};

const createSlidingDoorMountsGlazingGasketConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const hasTransom = MountsService.hasOverdoorTransom(partition);

    const sides = 2;
    const transomMultiplier = hasTransom ? 1 : sides;

    const totalDoorWidth = doorWidth * transomMultiplier;//top and bottom sides
    const horizontalGaskets = totalWidth * sides - totalDoorWidth;//top and bottom sides
    const verticalGaskets = totalHeight * sides;//left and right sides

    const qty = Math.round((horizontalGaskets + verticalGaskets) * sides) || 0; //inner and outer sides

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

const createSlidingDoorMountsFunctionalMullionsConfig = (
    partition: Partition,
): IComponentConfig => {
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const qty = MountsService.getFunctionalMullionLength(partition);

    return createMountsFunctionalMullionsConfig()
        .qty(2)
        .width(doorWidth)
        .area(qty)
        .build();
};

export const CGF300SlidingDoorsConfigs = (partition: Partition) => [
    createSlidingDoorMountsToptrackSlidingDoorConfig(partition),
    createSlidingDoorMountsCGFFrameVerticalConfig(partition),
    createSlidingDoorMountsCGFChannelVerticalConfig(partition),
    createSlidingDoorMountsCGFChannelHorizontalConfig(partition),
    createSlidingDoorMountsGlazingGasketConfig(partition),
    createSlidingDoorMountsFunctionalMullionsConfig(partition),
];
